export enum ReasonTagVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}
